import classNames from 'classnames'
import { h, JSX } from 'preact'

import { Numberfield, NumberfieldProps } from '../forms/numberfield/numberfield'

export interface ProductVariantRowProps {
    id: number
    name: string | null
    unitPrice: string
    quantityInput: NumberfieldProps
    quantity: number
    onRemove?: () => void
    totalPrice: string
}

export const ProductVariantRow = (props: ProductVariantRowProps): JSX.Element => {
    const { name } = props

    const priceClass = classNames(
        'product-variant-row__price',
        props.quantity === 0 && 'product-variant-row__price--disabled',
    )

    return (
        <div className="product-variant-row">
            {name && <div class="product-variant-row__name">{name}</div>}
            <div className="product-variant-row__data">
                <div className="product-variant-row__quantity">
                    <Numberfield modifier="numberfield--hide-label" {...props.quantityInput} />
                </div>
                <div className={priceClass}>
                    {props.quantity > 0 ? props.totalPrice : props.unitPrice}
                </div>
            </div>
        </div>
    )
}
